import { Injectable } from '@angular/core';

import { isDefined } from '@frontend/sports/common/core/utils/extended-types';

import { HandleType, IHandleProps } from './model';

@Injectable({ providedIn: 'root' })
export class SliderService {
    minHandleProps: IHandleProps = { step: 0, left: undefined };
    maxHandleProps: IHandleProps = { step: 0, left: undefined };

    maxStep: number;
    range: boolean;
    private handleOffset: number;
    private handleStep: number;

    setHandleOffset(handleOffset: number): void {
        this.handleOffset = handleOffset;
        this.handleStep = (100 - handleOffset * 2) / this.maxStep;

        this.updateHandlePositions();
    }

    updateSteps(values: number[], minValue: number, maxValue: number | undefined): void {
        let update = this.tryMapValueToStep(values, minValue, this.minHandleProps);

        if (this.range && isDefined(maxValue)) {
            update = this.tryMapValueToStep(values, maxValue, this.maxHandleProps) || update;
        }

        if (update) {
            this.updateHandlePositions();
        }
    }

    handleStepChange(newStepPosition: number, handle: HandleType): boolean {
        const newStep = Math.round(newStepPosition);
        const update = handle === HandleType.MinHandle ? this.updateMinHandleStep(newStep) : this.updateMaxHandleStep(newStep);
        if (update) {
            this.updateHandlePositions();
        }

        return update;
    }

    findClosestHandle(stepPosition: number): HandleType {
        return Math.abs(this.minHandleProps.step - stepPosition) > Math.abs(this.maxHandleProps.step - stepPosition)
            ? HandleType.MaxHandle
            : HandleType.MinHandle;
    }

    private updateHandlePositions(): void {
        if (!this.handleOffset && !this.handleStep) {
            return;
        }

        const calculate = (value: number) => this.handleOffset + value * this.handleStep;

        this.minHandleProps.left = calculate(this.minHandleProps.step);
        if (this.range) {
            this.maxHandleProps.left = calculate(this.maxHandleProps.step);
        }
    }

    private updateMinHandleStep(newStep: number): boolean {
        if (newStep < 0) {
            newStep = 0;
        } else if (this.range && newStep >= this.maxHandleProps.step) {
            newStep = this.maxHandleProps.step - 1;
        } else if (newStep > this.maxStep) {
            newStep = this.maxStep;
        }

        if (this.minHandleProps.step === newStep) {
            return false;
        }

        this.minHandleProps.step = newStep;

        return true;
    }

    private updateMaxHandleStep(newStep: number): boolean {
        if (newStep > this.maxStep) {
            newStep = this.maxStep;
        } else if (newStep <= this.minHandleProps.step) {
            newStep = this.minHandleProps.step + 1;
        }

        if (this.maxHandleProps.step === newStep) {
            return false;
        }

        this.maxHandleProps.step = newStep;

        return true;
    }

    private tryMapValueToStep(values: number[], value: number, handleProps: IHandleProps): boolean {
        const newStep = values.indexOf(value);
        if (newStep === -1 || newStep === handleProps.step) {
            return false;
        }

        handleProps.step = newStep;

        return true;
    }
}
